var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0C2.85 0 0 2.61822 0 6.66751C0 9.25321 1.8375 12.2942 5.505 15.7988C5.79 16.0671 6.2175 16.0671 6.5025 15.7988C10.1625 12.2942 12 9.25321 12 6.66751C12 2.61822 9.15 0 6 0ZM6 8.13111C5.175 8.13111 4.5 7.39931 4.5 6.50489C4.5 5.61047 5.175 4.87867 6 4.87867C6.825 4.87867 7.5 5.61047 7.5 6.50489C7.5 7.39931 6.825 8.13111 6 8.13111Z",
    fill: "#B4B5B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4a3dffbd55808fab15505b9d127daf94.svg";
export { ForwardRef as ReactComponent };